/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { IValidationRule } from "./model";

export function isValidationRule(obj: any, _argumentName?: string): obj is IValidationRule {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.countryCode === "string" &&
        typeof obj.shopId === "string" &&
        typeof obj.hasPhoneCountryCode === "boolean" &&
        typeof obj.phonePattern === "string" &&
        (typeof obj.phoneCountryCodePattern === "undefined" ||
            obj.phoneCountryCodePattern === null ||
            typeof obj.phoneCountryCodePattern === "string") &&
        (typeof obj.phoneMask === "undefined" ||
            obj.phoneMask === null ||
            typeof obj.phoneMask === "string") &&
        typeof obj.isPhoneCountryCodePatternMandatory === "boolean" &&
        (typeof obj.zipCodePattern === "undefined" ||
            obj.zipCodePattern === null ||
            typeof obj.zipCodePattern === "string") &&
        (typeof obj.zipCodeMask === "undefined" ||
            obj.zipCodeMask === null ||
            typeof obj.zipCodeMask === "string") &&
        typeof obj.dicPattern === "string" &&
        typeof obj.hasSeparateHouseNumber === "boolean" &&
        typeof obj.streetPattern === "string" &&
        (typeof obj.personalIdentificationNumberPattern === "undefined" ||
            obj.personalIdentificationNumberPattern === null ||
            typeof obj.personalIdentificationNumberPattern === "string")
    )
}
